<template>
    <div>
        <div class="spinner bg-white" v-if="showLoader">
      <div>
        <b-spinner variant="main" class="loader" type="grow" label="Spinning"></b-spinner>
      </div>
    </div>
    </div>
</template>
<script>
export default{
    name: 'SubscriptionSuccess',
    data() {
        return {
            showLoader: false,
        }
    },
    mounted() {
        this.showLoader = true;
        setTimeout(() => {
            this.showLoader = false;
            this.$router.push("/");
        }, 3000);
    },  
}
</script>